import { type ReactNode } from 'react';
import { AppearanceImage } from '../../../AppearanceImage';
import styles from './InstructionItem.module.css';

/**
 * Один шаг инструкции по установке PWA.
 *
 * Если передан `srcSet` — отображает изображение под заголовком.
 * Изображение адаптируется под тему: `srcSet` для светлой, `darkSrcSet` для тёмной.
 * Если изображение не нужно — передавать `srcSet` не требуется.
 *
 * @example
 * // Шаг с изображением
 * <Instruction.Item
 *   title="Нажмите кнопку «Поделиться»"
 *   srcSet={imageGetters.iosSteps('share-button')}
 *   darkSrcSet={imageGetters.iosSteps('share-button-dark')}
 *   aspectRatio={540/148}    // число
 *   aspectRatio="540/148"    // строка — эквивалентно
 *   aspectRatio="16/9"       // или стандартное соотношение
 * />
 *
 * @example
 * // Шаг без изображения
 * <Instruction.Item title="Готово" />
 */
type InstructionItemProps = {
  title: ReactNode;
} & (
  | { srcSet: string; aspectRatio: number | string; darkSrcSet?: string }
  | { srcSet?: never; aspectRatio?: never; darkSrcSet?: never }
);

export function InstructionItem(props: InstructionItemProps) {
  const { title, srcSet, darkSrcSet, aspectRatio } = props;

  return (
    <li className={styles.root}>
      {title}
      {srcSet && (
        <AppearanceImage className={styles.image} light={srcSet} dark={darkSrcSet} aspectRatio={aspectRatio} />
      )}
    </li>
  );
}
